









































import { Vue, Component, Prop } from 'vue-property-decorator';
import Person from '@/components/Person.vue';
import { IRecipient } from '@/types/Recipient';
import { IUser } from '@/types/User';

@Component({
  components: {
    Person,
  },
})
export default class ConnectFieldContent extends Vue {
  @Prop() sender!: IUser;
  @Prop() recipients: IRecipient[];
  @Prop() selectedRecipientId?: string;
  @Prop() allFieldsConnectedToSender: boolean;
  @Prop({ default: false }) dark: boolean;
  @Prop({ default: false }) small: boolean;
  @Prop() connectFirstRecipient?: boolean;
  @Prop() isTemplate: boolean;

  setBorderColorRecipient(recipient: IRecipient): string {
    return recipient.id === this.selectedRecipientId ? 'green' : '';
  }

  setBorderColorSender(sender: IUser): string {
    return sender && this.allFieldsConnectedToSender ? 'orange' : '';
  }

  isSenderSelected(sender: IUser): boolean {
    return sender && !this.selectedRecipientId && !this.connectFirstRecipient;
  }

  isRecipientSelected(recipient: IRecipient): boolean {
    return this.selectedRecipientId === recipient.id;
  }

  setSender(sender: IUser): void {
    this.$emit('setSender', sender);
  }

  setRecipient(recipient, connectFirstRecipient: boolean): void {
    this.$emit('setRecipient', { recipient, connectFirstRecipient });
  }
}
